// import { SessionSearchResponse, SessionSearchFilter, SessionCreateRequest, Workout } from '@api/entities';
import { SessionCreateRequest, SessionSearchFilter, SessionSearchResponse, SessionTitleUpdate, Workout } from 'src/api/entities';
import { IWorkoutApiService, WorkoutApiService } from '../services/workout/workout.spi.service';

export class WorkoutManager {
    private static instance: WorkoutManager;
    private workoutService: IWorkoutApiService;

    private constructor() {
        this.workoutService = WorkoutApiService.getInstance(process.env.REACT_APP_MICROSERVICE_AUTH_BASEPATH!);
    }

    static getInstance() {
        if (WorkoutManager.instance == null) {
            WorkoutManager.instance = new WorkoutManager();
        }
        return WorkoutManager.instance;
    }

    async search(customerID?: number, archived?: boolean): Promise<SessionSearchResponse> {
        const filter: SessionSearchFilter = {
            assigneeID: customerID,
            archived: archived ?? false
        };

        const response: SessionSearchResponse = await this.workoutService.search(0, 100, undefined, undefined, filter);
        return response;
    }

    async create(request: SessionCreateRequest): Promise<Workout> {
        const response = await this.workoutService.create(request);
        return response;
    }

    async archive(id: number, archive: boolean): Promise<Workout> {
        return (await this.workoutService.archive(id, archive));
    }

    async rename(id: number, sessionTitleUpdate: SessionTitleUpdate): Promise<Workout> {
        return (await this.workoutService.rename(id, sessionTitleUpdate));
    }

    async getById(id: number): Promise<Workout> {
        const response = await this.workoutService.getById(id);
        return response;
    }

    async delete(id: number): Promise<{ [key: string]: boolean }> {
        const response = await this.workoutService.delete(id);
        return response;
    }
}
